import React, { useEffect, useRef } from 'react';
import { Form, Select, Input, Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import './index.scss';

const AlarmRuleModule = ({ 
    form, 
    sensorOptions, 
    rankOptions,
    operatorOptions,
    onSubmit,
    onCancel
}) => {
    const moduleRef = useRef(null);

    useEffect(() => {
        const module = moduleRef.current;
        requestAnimationFrame(() => {
            module.classList.add('visible');
        });

        return () => {
            module.classList.remove('visible');
        };
    }, []);

    const handleClose = () => {
        const module = moduleRef.current;
        module.classList.remove('visible');
        setTimeout(onCancel, 300);
    };

    return (
        <div className="alarm-rule-module" ref={moduleRef} onClick={e => e.stopPropagation()}>
            <div className="module-header">
                <h3>{form.getFieldValue('id') ? '編輯警報規則' : '新增警報規則'}</h3>
                <Button className="close-btn" icon={<CloseOutlined />} onClick={handleClose} />
            </div>
            <div className="module-content">
                <Form
                    form={form}
                    onFinish={onSubmit}
                    layout="vertical"
                    className="custom-form"
                >
                    <Form.Item name="id" hidden>
                        <Input />
                    </Form.Item>

                    <Form.Item name="log_id" hidden>
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="sensor_id"
                        label={<>* 感測器類型</>}
                        rules={[{ required: true, message: '請選擇感測器類型' }]}
                    >
                        <Select
                            options={sensorOptions[form.getFieldValue('log_id')] || []}
                            placeholder="請選擇感測器類型"
                        />
                    </Form.Item>

                    <Form.Item
                        name={['rules', 'HH']}
                        label={<>* HH (極高) 警戒值</>}
                        rules={[
                            { required: true, message: '請輸入極高警戒值' },
                            { 
                                type: 'number',
                                transform: (value) => parseFloat(value),
                                message: '請輸入有效的數字'
                            }
                        ]}
                    >
                        <Input type="number" placeholder="請輸入極高警戒值" />
                    </Form.Item>

                    <Form.Item
                        name={['rules', 'H']}
                        label={<>* H (高) 警戒值</>}
                        rules={[
                            { required: true, message: '請輸入高警戒值' },
                            { 
                                type: 'number',
                                transform: (value) => parseFloat(value),
                                message: '請輸入有效的數字'
                            }
                        ]}
                    >
                        <Input type="number" placeholder="請輸入高警戒值" />
                    </Form.Item>

                    <Form.Item
                        name={['rules', 'L']}
                        label={<>* L (低) 警戒值</>}
                        rules={[
                            { required: true, message: '請輸入低警戒值' },
                            { 
                                type: 'number',
                                transform: (value) => parseFloat(value),
                                message: '請輸入有效的數字'
                            }
                        ]}
                    >
                        <Input type="number" placeholder="請輸入低警戒值" />
                    </Form.Item>

                    <Form.Item
                        name={['rules', 'LL']}
                        label={<>* LL (極低) 警戒值</>}
                        rules={[
                            { required: true, message: '請輸入極低警戒值' },
                            { 
                                type: 'number',
                                transform: (value) => parseFloat(value),
                                message: '請輸入有效的數字'
                            }
                        ]}
                    >
                        <Input type="number" placeholder="請輸入極低警戒值" />
                    </Form.Item>

                    <Form.Item
                        name="is_active"
                        label="狀態"
                        initialValue={true}
                    >
                        <Select>
                            <Select.Option value={true}>啟用</Select.Option>
                            <Select.Option value={false}>停用</Select.Option>
                        </Select>
                    </Form.Item>

                    <div className="form-buttons">
                        <Button onClick={handleClose}>
                            取消
                        </Button>
                        <Button type="primary" htmlType="submit">
                            {form.getFieldValue('id') ? '更新' : '確定'}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default AlarmRuleModule; 